import { mergeDefaultConfig, validateConfig } from "./logic/core";
import { findHistorySuggestRoot, findWordSuggestRoot, setupEventHandlers } from "./ui/common";
import { createUIHandlerPC } from "./ui/pc";
import { createUIHandlerSP } from "./ui/sp";

window.setupSuggest = setupSuggest;

/**
 * サジェストの初期化を行う。
 *
 * @param {InputSuggestConfig} inputConfig サジェスト表示設定
 * @returns {void}
 */
export function setupSuggest(inputConfig) {
  validateConfig(inputConfig);
  const config = mergeDefaultConfig(inputConfig);
  const uiHandler = createUIHandler(inputConfig.type);

  /** @type {SuggestContext} */
  const context = {
    config,
    uiHandler,
  };

  const wordSuggestRoot = findWordSuggestRoot(config);
  uiHandler.renderWordSuggestRoot(context, wordSuggestRoot);
  const historySuggestRoot = findHistorySuggestRoot(config);
  uiHandler.renderHistorySuggestRoot(context, historySuggestRoot);

  /** @type {JQuery<HTMLInputElement>} */
  const triggerElements = $(config.triggerTarget);
  if (triggerElements.length < 1) {
    throw new Error('要素が見つかりません。');
  }
  setupEventHandlers(triggerElements, context);
}

/**
 * ビューレンダラーを生成する。
 *
 * @param {SuggestUIType} type 表示タイプ
 * @returns {UIHandler}
 */
function createUIHandler(type) {
  switch (type) {
    case 'pc':
      return createUIHandlerPC();
    case 'sp':
      return createUIHandlerSP();
    default:
      throw new Error('値が不適切です。');
  }
}
